import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './GeneralInfoForm.css';

const CityForm = ({ cityId, initialData, onSuccess }) => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
  const [cityName, setCityName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // ✅ Fill form if initialData is provided (edit mode)
  useEffect(() => {
    if (initialData && initialData.city) {
      setCityName(initialData.city);
    }
  }, [initialData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!cityName.trim()) {
      setError('City name is required');
      return;
    }

    setLoading(true);
    setError('');

    try {
      let url = '';
      let method = 'POST';
      let body = {};

      if (cityId) {
        // ✅ Edit mode
        url = `${baseUrl}/updateCityById/${cityId}`;
        body = { city: cityName };
      } else {
        // ✅ Create mode
        url = `${baseUrl}/createCity`;
        body = { city: cityName };
      }

      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (data.status) {
        alert(cityId ? 'City updated successfully' : 'City created successfully');
        if (onSuccess) onSuccess();
        navigate('/city');
      } else {
        setError(data.message || `Failed to ${cityId ? 'update' : 'create'} CITY`);
      }
    } catch (err) {
      setError('Error connecting to server');
    } finally {
      setLoading(false);
    }
  };

   const handleCloseModal = () => {
    navigate('/city');
  };

  return (
    <form className="general-info-form" onSubmit={handleSubmit}>
      <h2 className="section-title">{cityId ? 'Edit City' : 'Add City'}</h2>
      <div className="form-grid">
        <div className="form-floating">
          <input
            type="text"
            className="form-control"
            id="cityName"
            placeholder=" "
            autoComplete="off"
            value={cityName}
            onChange={(e) => setCityName(e.target.value)}
            disabled={loading}
          />
          <label htmlFor="cityName">City Name</label>
        </div>
      </div>
      <div style={{ marginTop: '15px', display: 'flex', gap: '10px' }}>
      {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
      <button
        type="submit"
        className="btn btn-primary"
        
        disabled={loading}
      >
        {loading ? 'Saving...' : 'Save'}
      </button>
      <button
      type="button"
      
      className="btn btn-secondary"
      onClick={handleCloseModal}
      disabled={loading}
    >
      Cancel
    </button>
    </div>
    </form>
  );
};

export default CityForm;
